import { createContext } from 'react';
var DatagridContext = createContext({});
DatagridContext.displayName = 'DatagridContext';
export default DatagridContext;
//# sourceMappingURL=DatagridContext.js.map